export const PreSupportPromptAction = {
  CONTACT_SUPPORT: 'pre_support_prompt.event.user.contactSupport',
  RESTART_CHAT: 'pre_support_prompt.event.user.restartChat',
  END_CHAT: 'pre_support_prompt.event.user.endChat',
  EXPLORE_ARTICLES: 'pre_support_prompt.event.user.exploreArticles',
  POSITIVE_RESOLUTION: 'pre_support_prompt.event.user.positiveResolution',
} as const;

export type PreSupportPromptActionKind = typeof PreSupportPromptAction[keyof typeof PreSupportPromptAction]
